<template>
  <div :class="[baseCss, dirty ? `${baseCss}-dirty` : null, disabled ? ['disabled', 'pointer-events-none'] : null]">
    <async-form :form-data="{}" @submit="addChip">
      <table-layout :class="[`${baseCss}-chips-table`]">
        <row>
          <cell v-if="iconLeft" :class="[`${baseCss}-icon-cell`]" x-align="center">
            <icon :color="dirty ? color : null" :color-lightness="dirty ? colorLightness : null" @click="$emit('left-icon-click')" :name="iconLeft" :icon-provider="iconProvider" :class="['mt-2']" />
          </cell>
          <cell :class="[`${baseCss}-chips-cell`]">
            <ul :class="['flex', 'flex-wrap', 'items-start']">
              <li v-for="(chip, index) in list" :key="index">
                <chip :color="labelColor" :color-lightness="labelColorLightness" :bg-color="color" :bg-color-lightness="colorLightness" @dismiss="onChipDismiss(index)" v-model="chip.model" dismissible>{{ chip.label }}</chip>
              </li><li :style="{minWidth: inputMinWidth}" :class="['flex-1']">
              <text-field @keyup="onKeyup" :error="error" @focus="dirty = true" @blur="dirty = false" :disabled="disabled" :placeholder="placeholder" :color="color" :color-lightness="colorLightness" v-model="input" />
            </li>
            </ul>
          </cell>
          <cell v-if="showButton" :class="[`${baseCss}-button-cell`]" x-align="center">
            <btn :class="['mt-1']" size="sm" type="submit" :bg-color="color" :bg-color-lightness="colorLightness" :color="labelColor" :color-lightness="labelColorLightness" :icon-left="buttonIcon" :icon-provider="iconProvider" />
          </cell>
          <cell v-if="iconRight" :class="[`${baseCss}-icon-cell`]" x-align="center">
            <icon :color="dirty ? color : null" :color-lightness="dirty ? colorLightness : null" @click="$emit('right-icon-click')" :name="iconRight" :icon-provider="iconProvider" :class="['mt-2']" />
          </cell>
        </row>
      </table-layout>
    </async-form>
  </div>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'ChipInput',
  mixins: [
    methods
  ],
  data () {
    return {
      input: '',
      dirty: false,
      errorType: null,
      errorTypes: [
        'chips-max-length',
        'dupes-not-allowed'
      ],
      baseCss: this.componentBaseCss('chip-input', [])
    }
  },
  model: {
    prop: 'chips',
    event: 'input'
  },
  props: {
    allowDupes: {
      type: Boolean,
      default: false
    },
    messageDupesNotAllowed: {
      type: String,
      default: 'duplicates are not allowed'
    },
    chipsMaxLength: {
      type: Number
    },
    messageChipsMaxLengthReached: {
      type: String,
      default: 'you cannot add more chips'
    },
    chips: {
      type: Array,
      default: () => {
        return []
      }
    },
    color: {
      type: String
    },
    colorLightness: {
      type: Number
    },
    labelColor: {
      type: String
    },
    labelColorLightness: {
      type: Number
    },
    iconLeft: {
      type: String
    },
    iconRight: {
      type: String
    },
    iconProvider: {
      type: String,
      default: 'mdi'
    },
    buttonIcon: {
      type: String,
      default: 'plus'
    },
    placeholder: {
      type: String
    },
    showButton: {
      type: Boolean,
      default: false
    },
    inputMinWidth: {
      type: String,
      default: '25%'
    },
    disabled: {
      type: Boolean
    }
  },
  computed: {
    list () {
      return this.chips.map(label => {
        return {
          label,
          model: true
        }
      })
    },
    error () {
      switch (this.errorType) {
        case this.errorTypes[0]:
          return this.messageChipsMaxLengthReached
        case this.errorTypes[1]:
          return this.messageDupesNotAllowed
        default:
          return null
      }
    }
  },
  methods: {
    addChip () {
      const input = this.input
      this.errorType = null
      if (input && !this.disabled) {
        if (this.chipsMaxLength && this.chipsMaxLength === this.chips.length) {
          this.errorType = this.errorTypes[0]
          this.input = ''
          return
        }
        if (!this.allowDupes && this.chips.includes(input)) {
          this.errorType = this.errorTypes[1]
          this.input = ''
          return
        }
        if (!this.input.replace(/\s/g, '').length) {
          this.input = ''
          return
        }
        this.chips.push(input.trim())
        this.$emit('input', {
          chips: this.chips,
          added: input,
          removed: null
        })
        this.$nextTick(() => {
          this.input = ''
        })
      }
    },
    onKeyup ($event) {
      const length = this.chips.length
      if ($event.code === 'Backspace' && this.input === '' && length) {
        this.onChipDismiss(length - 1)
      }
    },
    onChipDismiss (index) {
      if (!this.disabled) {
        const removed = this.chips[index]
        this.errorType = null
        this.chips.splice(index, 1)
        this.$emit('input', {
          removed,
          added: null,
          chips: this.chips
        })
      }
    }
  }
}
</script>
<style>
.bcq-chip-input .bcq-chip-input-icon-cell
{
  width: 32px;
}

.bcq-chip-input .bcq-chip-input-button-cell
{
  width: 50px;
}

.bcq-chip-input .bcq-text-field
{
  margin-top: -8px;
}

.bcq-chip-input li,
.bcq-chip-input .bcq-chip-input-button-cell
{
  padding: 2px;
}

.bcq-chip-input li:first-child
{
  padding-left: 0;
}

.bcq-chip-input .truncate,
.bcq-chip-input li:last-child
{
  padding-right: 0;
}

.bcq-chip-input .bcq-chip-input-chips-cell .bcq-chip
{
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/chip-input/chip-input.vue